import Notiflix from 'notiflix';

export default Notiflix;